import classNames from 'classnames'
import * as React from 'react'
import IAnswer from '../../../data/questionnaires/IAnswer'

import { Typography } from '@material-ui/core'

import './style.scss'

interface IProps {
  answer: IAnswer
  onClick: () => void
  active?: boolean
  colored?: boolean
  colorIndex?: number
}
interface IState {}

class Answer extends React.Component<IProps, IState> {
  render() {
    const { answer, onClick, colored, active } = this.props
    return (
      <div
        className={classNames(
          'answer',
          active && 'checked',
          colored && 'colored'
        )}
        onClick={onClick}
      >
        <Typography className="answer-title">
          {colored || !answer.subAnswer
            ? answer.answer
            : `${answer.answer} - ${answer.subAnswer}`}
        </Typography>
        {colored && answer.subAnswer && (
          <Typography className="sub-answer">{answer.subAnswer}</Typography>
        )}
      </div>
    )
  }
}

export default Answer



// WEBPACK FOOTER //
// ./src/pages/Questionnaires/Answer/index.tsx